/** @jsx jsx */
import { jsx, Box } from 'theme-ui';
import React, { FunctionComponent } from 'react';

// Components
import FluidImage from '@codersclan/gatsby-theme-airfleet/src/components/fluidImage';
import Text, { TEXT_TYPES } from '../text';

// Styles
import { baseStyle } from './style';

export interface IconColumnProps {
  image?: ImageType;
  title?: string;
  paragraph?: string;
  number?: string;
  subtext?: string;
  className?: string;
}

const IconColumn: FunctionComponent<IconColumnProps> = React.memo(
  ({
    image,
    title,
    paragraph,
    number,
    subtext,
    className,
  }: IconColumnProps) => (
    <Box sx={baseStyle.mainContainer} className={className}>
      {image && (
        <Box sx={baseStyle.imageContainer}>
          <FluidImage {...image} sx={baseStyle.image} />
        </Box>
      )}
      {title && (
        <Text type={TEXT_TYPES.SIDEBAR_H1} sx={baseStyle.title} lines="1">
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </Text>
      )}
      {paragraph && (
        <Text
          type={TEXT_TYPES.BODY_INTRO}
          sx={baseStyle.paragraph}
          className="paragraph-color"
          lines="2"
        >
          <span dangerouslySetInnerHTML={{ __html: paragraph }} />
        </Text>
      )}
      {number && (
        <Text
          type={TEXT_TYPES.SIDEBAR_NUMBERS}
          sx={baseStyle.numbers}
          lines="1"
        >
          {number}
        </Text>
      )}
      {subtext && (
        <Text type={TEXT_TYPES.BODY_INTRO} sx={baseStyle.subtext} lines="2">
          <span dangerouslySetInnerHTML={{ __html: subtext }} />
        </Text>
      )}
    </Box>
  ),
);

export default IconColumn;
